import React from "react";
import { useFaildReports, useFlashReports, useReports, useUpdateCorrection } from "../../projectManagementQueries";
import { LSDBCoreTable } from "../../../common/LSDBCoreTable";
import {
  Button, Checkbox, Grid, LinearProgress, Paper, TableContainer, TextField, Typography, IconButton,
  Radio,
  Icon,
  Tooltip,
} from "@material-ui/core";
import { ErrorMessage } from "../../../common/ErrorMessage";
import { generalFilter, useDefaultColumn } from "../../../../util/filter";
import { useHistory } from "react-router";
import { TravelerModal } from "../../../common/travelerModal";
import { useFetchContext } from "../../../common/FetchContext";
import { urls } from "../../../common/urls";
import moment from "moment";
import { toast } from "react-toastify";
import { HeaderProps, Row, useFilters, useGlobalFilter, usePagination, useRowSelect, useSortBy, useTable } from "react-table";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Alert, AlertTitle } from "@material-ui/lab";
import MuiTable from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Container from "@material-ui/core/Container";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { renderHeader } from "../../../common/util";
import CallSplitIcon from "@material-ui/icons/CallSplit";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import * as Yup from "yup";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Link } from "@material-ui/core";
import { Edit, Label, PublishRounded, UpdateRounded } from "@material-ui/icons";
import CloseIcon from '@material-ui/icons/Close';
import { Link as MuiLink, useTheme } from "@material-ui/core/";
import { constant } from "lodash";
import { EditProjectItems } from "../myprojects/EditProjectItems";
import { Field, Form, Formik } from "formik";
import { processErrorOnMutation } from "../../../../util/errorMessaging";
import CustomDialog from "../../../common/CustomDialog";
import { formatDate } from "../../../common/formatDate";
import { useTransisLog } from "../../../intake/intakeQueries";




const TransistLogs = () => {

  const [startDate, setStartDate] = React.useState('');
  const [endDate, setEndDate] = React.useState('');
  const [transistLog, setTransistlog] = React.useState([]);



  const {
    mutateAsync: mutateTransisLog,
    error: errorMutateTransisLog,
    isError: isErrorMutateTransisLog,
    isSuccess: isSuccessTransisLogs,
    isLoading: isLoadingTransisLog,
  } = useTransisLog();

  const [open, setOpen] = React.useState(false);
  const [openOldMesurement, setOpenOldMesurement] = React.useState(false);
  const [oldValues, setOldValues] = React.useState<any>([]);

  const handleClose = () => {
    setOpen(!open);
  };

  const handleCloseOldMesurement = () => {
    setOpenOldMesurement(!openOldMesurement);
  };




  // React.useEffect(() => {
  //   setTransistlog(transistLog);
  // }, [transistLog.length, transistLog]);

  




  const handleStartDateChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {

    console.log(e)
    setStartDate(e.target.value);
  };

 
  const handleEndDateChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {
    setEndDate(e.target.value);
  };
  const searchData = async () => {


    if (startDate != '' && endDate != '') {
     try{
      var data = await mutateTransisLog({
        authAxios,
        startDate,
        endDate,
      });

      setTransistlog(data)
     }catch(err){
      toast.error("No data found")
      setTransistlog([])
    }

    } else {
      toast.warning('Please select start and end date')

    }


  };



  const { authAxios } = useFetchContext();
  const { mutateAsync: mutate } = useUpdateCorrection();


  const getDownloads = async (): Promise<any> => {
    if (transistLog.length != 0) {
      const response = await authAxios.get(urls.intake.transist_log_download(startDate, endDate), {
        responseType: 'blob'
      });

      const downloadUrl = URL.createObjectURL(response.data);
      let a = document.createElement("a");
      a.href = downloadUrl;
      a.download = `${moment().format("MMM-DD-YYYY-HHMMSS")}`;
      document.body.appendChild(a);
      a.click();

    } else {
      toast.warning('No data found to download')

    }

  };




  const defaultColumn = useDefaultColumn();

  const columns = React.useMemo(
    () => [

      {
        Header: "ID",
        id:'id',
        accessor: "id",
        filter: generalFilter,
      },
      {
        id:"Project",
        accessor:'project_number',
        filter: generalFilter,
      },
      {
        id:"Location",
        accessor:'location_name',
        filter: generalFilter,
      },
      {
        id:"User",
        accessor:'username',
        filter: generalFilter,
      },     
      {
        id:"Date Time",
        accessor:"datetime",
        Cell:({cell}:any)=>{
          return  <p>{formatDate(cell.value)}</p>
        }
      },
  
    ],
    []
  );

  // const columns = React.useMemo(
  //   () => [

  //     {
  //       Header: "ID",
  //       id:'id',
  //       accessor: "id",
  //       filter: generalFilter,
  //     },
  //     {
  //       id:"old_data",
  //       accessor:'old_correction_value'
  //     },
  //     {
  //       id:"Date Time",
  //       accessor:"date_time",
  //       Cell:({cell}:any)=>{
  //         return  <p>{formatDate(cell.value)}</p>

  //       }
  //     },
  //     {
  //       id: "Serial Number",
  //       accessor: "unit_serial_number",
  //       filter:generalFilter
  //       // Cell: ({ cell }: any) => {
  //       //   return <TravelerModal serialNumber={cell.value} />;
  //       // },
  //     },
  //     {
  //       id:"Project Number",
  //       accessor: "project_number",
  //       filter:generalFilter

  //     },
  //     {
  //       id:"Customer",
  //       accessor: "customer_name",
  //       filter:generalFilter
  //     },
  //     {
  //       id:"WorkOrder",
  //       accessor: "work_order_name",
  //       filter:generalFilter
  //     },
  //     {
  //       id: "Char Point",
  //       accessor: "name",
  //       filter: generalFilter
  //     },
  //     {
  //       Header:"Procedure",
  //       id: "Procedure",
  //       accessor: 'procedure_definition_name',
  //       filter: generalFilter
  //     },
  //     {
  //       Header:"Disposition",
  //       id: "disposition",
  //       accessor: 'disposition_name',
  //       filter: generalFilter
  //     },
  //     {
  //       Header:"Pmp",
  //       id: "pmp",
  //       accessor: "correction_factor.Pmp",
  //       filter: generalFilter
  //     },
  //     {
  //       Header:"Isc",
  //       id: "ISC",
  //       accessor: "correction_factor.Isc",
  //       filter: generalFilter,
  //     },
  //     {
  //       Header:"Voc",
  //       id: "VOC",
  //       accessor: "correction_factor.Voc",
  //       filter: generalFilter,
  //     },

  //     {
  //       Header:"Vmp",
  //       id: "VMP",
  //       accessor: "correction_factor.Vmp",
  //       filter: generalFilter,
  //     },
  //     {
  //       Header:"Imp",
  //       id: "IMP",
  //       accessor: "correction_factor.Imp",
  //       filter: generalFilter,
  //     },

    


  //     // {
  //     //   Header:'Corrected',
  //     //   Cell: ({ cell,row }: any) => {
         

  //     //     return row.values.old_data !== null ? (
  //     //       <Button
  //     //       color="primary"
  //     //       onClick={() => {
  //     //         setOldValues(row.values.old_data);
  //     //         setOpenOldMesurement(true);
  //     //       }}>Updated</Button>
  //     //     ) : (<></> );
  //     //   },
  //     //   filter: generalFilter,
  //     // },


  //   ],
  //   []
  // );


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    selectedFlatRows,
  
    state: { pageIndex, pageSize, selectedRowIds },
  } = useTable(
    {
      data: transistLog,

      columns,
      defaultColumn,
      initialState: {
        hiddenColumns: ["id", "url", "old_data"],
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header:
           ({ getToggleAllRowsSelectedProps }: HeaderProps<any>) => (
            <div>
              {/* <Checkbox {...getToggleAllRowsSelectedProps()} /> */}
            </div>
          ),
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
      
        },
        ...columns,
      ]);
    }
  );
 







  if (isLoadingTransisLog) {
    return <LinearProgress />;
  }

  // if (isErrorMutateTransisLog) {
  //   return  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
  //   <Typography variant="h5">No result found</Typography>
  // </div>
  // }



  return (
    <>
      <Typography variant="h5">Transit Logs</Typography>

      <div style={{ margin: 10, padding: 10 }}>
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent="space-between" // Ensure items are spread across the row
        >
          <Grid item xs={6} container justifyContent="flex-start" alignItems="center" spacing={2}>
            <Grid item >

              <TextField
                id="start-date"
                label="Start Date"
                type="date"
                value={startDate}
                onChange={handleStartDateChange}
                InputLabelProps={{
                  shrink: true, // Keeps the label visible when a value is selected
                }}
                variant="outlined" // Adds an outline to the input
              />
            </Grid>

            <Grid item >
              <TextField
                id="end-date"
                label="End Date"
                type="date"
                value={endDate}
                onChange={handleEndDateChange}
                InputLabelProps={{
                  shrink: true, // Keeps the label visible when a value is selected
                }}
                variant="outlined" // Adds an outline to the input
              />
            </Grid>

            <Grid item>
              <Button
                variant="outlined" // Outlined button
                color="primary"
                onClick={searchData}
              >
                SEARCH
              </Button>
            </Grid>
           
          </Grid>

          {transistLog.length!=0 ? (
            <Grid item xs={6} container justifyContent="flex-end" spacing={2}>
            
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={getDownloads}
                >
                  Download Transit Logs
                </Button>
              </Grid>
            </Grid>
          ) : null}
        </Grid>

      </div>
      {/* {flashReports.length ? <FlashReport reports={flashReports} /> :
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
          <Typography variant="h5">No result found</Typography>
        </div>
      } */}
      {transistLog.length!=0  ?

        <TableContainer
          data-testid="tableContainer"
          // style={theme.tableContainer}
      
          component={Paper}
        >
         <MuiTable  stickyHeader {...getTableProps()} size="small">
            <TableHead>
              {headerGroups.map((headerGroup) => (
                <TableRow {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <TableCell  style={{ whiteSpace: 'nowrap' }}>
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        wrap="nowrap" 
                        spacing={0}
                      >
                        <Grid item {...column.getHeaderProps()}>
                          <Grid
                            container
                            direction="row"
                            alignItems="center"
                            spacing={0}
                            wrap="nowrap"
                          >
                            <Typography variant="subtitle1" noWrap>
                              {renderHeader(column)}
                            </Typography>
                            {column.canFilter ? column.render("Filter") : null}
                            <Grid item wrap="nowrap">
                              {/* <IconButton
                                type="submit"
                                aria-label="search"
                                size="small"
                                {...column.getSortByToggleProps()}
                              >
                                {column.isSorted ? (
                                  column.isSortedDesc ? (
                                    <ArrowDropDownIcon />
                                  ) : (
                                    <ArrowDropUpIcon />
                                  )
                                ) : (
                                  column.id !== "selection" && <CallSplitIcon />
                                )}
                              </IconButton> */}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableHead>
            <TableBody {...getTableBodyProps()}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <TableRow {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <TableCell {...cell.getCellProps()}  style={{ whiteSpace: 'nowrap' }}>
                          {cell.render("Cell")}
                          {/* {cell.column.id === "select" ? (
                            <Checkbox
                              checked={selectedRowId === row.values.id} // Check if this row is selected
                              onChange={() => handleRowSelect(row.values.id)} // Update selected row on change
                            />
                          ) : (
                            cell.render("Cell")
                          )} */}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </MuiTable>
        </TableContainer>
        :
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
          <Typography variant="h5">No result found</Typography>
        </div>
      }

    </>
  );
};

export default TransistLogs;
